import React from 'react';
import { Col as AntdCol } from 'antd/es/grid/index';
import { ConfigContext } from '../config-provider';
// eslint-disable-next-line react/display-name
const Col = React.forwardRef((props, ref) => {
    const { prefixCls, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('col', prefixCls);
    return React.createElement(AntdCol, { ref: ref, prefixCls: classPrefix, ...otherProps });
});
export default Col;
